import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_REGISTRATION_FEATURE_KEY,
  PaymentRegistrationState,
} from './paymentRegistration.slice';

export const getRegistrationState = (
  rootState: any,
): PaymentRegistrationState => rootState[PAYMENT_REGISTRATION_FEATURE_KEY];

export const selectRegistrationResultAction = createSelector(
  getRegistrationState,
  (s) => s.resultAction,
);

export const selectRegistrationError = createSelector(
  getRegistrationState,
  (s) => s.error,
);
